import { Injectable } from '@angular/core';

import { IClientsSocis, IClientsSocisResponse } from '../../clientsSocis/clientssocis.interfaces';

import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';


@Injectable()
export class ClientsSocisService {

  private options: {
    headers?: HttpHeaders,
    observe?: 'body',
    params?: HttpParams,
    reportProgress?: boolean,
    responseType: any,
    withCredentials?: boolean
  };

  public getList(limit = 10, skip = 0, filters = {}, conds = {}, ordering = {}, exportar = false): Observable<IClientsSocisResponse> {
    let params = new HttpParams();
    params = params.append('limit', limit.toString());
    params = params.append('skip', skip.toString());
    
    Object.keys(filters)
      .filter(filter => (filters[filter] === 0 || filters[filter]))
      .forEach(filter => params = params.append(filter, filters[filter].toString()));

    Object.keys(conds)
      .filter(cond => (conds[cond] === 0 || conds[cond]))
      .forEach(cond => params = params.append(cond, conds[cond].toString()));

    Object.keys(ordering).filter(field => (ordering[field] === 0 || ordering[field]))
    .forEach(field => params = params.append((ordering[field] === 'ASC' ? 'orderAsc' : 'orderDesc'), field));

    params = params.append('export', exportar.toString());

    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json',
      params: params 
    }

    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + "clientssocis", this.options)
      .pipe(map(response => { return response || [] }));
  }
  
  public getAutocomplete(id: string): Observable<Array<{value: string, text: string}>> {
    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json'
    }
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'autocomplete/' + id, this.options)
    .pipe(map(response => { return response || [] }));
  }

  public setClientFinal(idP, idClient, quin){
    return this.authHttp.post(APIURLConstantsService._API_BASE_URL + quin + '/'+idP+'/final/'+(idClient?idClient:''),{})
    .pipe(map(response => response || []));
  }

  public getContactesClientSoci(clientSociId ): Observable<Array<any>> {
    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json'
    }
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'clientssocis/' + clientSociId + '/contactes', this.options)
    .pipe(map(response => response || []));
  }

  public get(tipus, projectId): Observable<Array<any>> {
    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json'
    }
    //Clients per les propostes
  	if(tipus == 'Clients')return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'clients')
      .pipe(map(response => response || []));
    //Socis per les propostes
    if(tipus == 'Socis')return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'socis')
      .pipe(map(response => response || []));
    //Clients del projecte per trial els contactes
    if(tipus !== 'Socis' && tipus !== 'Clients')
      return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'proposal/'+ projectId + '/clients', this.options)
      .pipe(map(response => {
        const projectData: any = response || [];
        return projectData;
      }));
  }

  public getClientSociTipus() {
    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json'
    }
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'clientssocistipus', this.options)
      .pipe(map(response => response || []));
  }

  public getClientSoci(idClientSoci): Observable<IClientsSocisResponse> {
    this.options = {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
      responseType: 'json'
    }
    return this.authHttp.get<any>(APIURLConstantsService._API_BASE_URL + 'clientssocis/' + idClientSoci, this.options)
      .pipe(map(response => response || []));
  }
  
  public createClientSoci(data): Observable<any> {
    return this.authHttp.put(APIURLConstantsService._API_BASE_URL + 'clientssocis', data)
      .pipe(map(response => response || {}));
  }

  public updateClientSoci(id, data): Observable<any> {
    return this.authHttp.post(APIURLConstantsService._API_BASE_URL + 'clientssocis/'+id, data)
      .pipe(map(response => response || {}));
  }
  
  public deleteClientSoci(id): Observable<any> {
    return this.authHttp.delete(APIURLConstantsService._API_BASE_URL + 'clientssocis/'+id)
      .pipe(map(response => response || {}));
  }


  constructor(private authHttp: HttpClient) {}
}
